// extracted by mini-css-extract-plugin
module.exports = {"bundle":"bundle_bundle__3F7Ab","trash":"bundle_trash__lfWHU"};